// Persists `this.filters` to localStorage under `this.filterName`. Hosting
// component must declare `filterName` and a reactive `filters` object.
// Optionally declare `filterExclude` (array of keys) to omit from storage.
//
// Persists on every filter change (deep watch) and on component unmount.
// Vue Router 4 in-component guards from a mixin can be skipped — e.g. when
// navigating to a child route — so we no longer rely on beforeRouteLeave.

export default {
    created() {
        if (!this.filterName) return;
        const stored = localStorage.getItem(this.filterName);
        if (stored != null) {
            try {
                Object.assign(this.filters, JSON.parse(stored));
            } catch (_) {
                // Corrupt entry — ignore and let defaults stand.
            }
        }
    },
    watch: {
        filters: {
            deep: true,
            handler() {
                this.$_saveSearchFilters();
            }
        }
    },
    beforeUnmount() {
        this.$_saveSearchFilters();
    },
    methods: {
        $_saveSearchFilters() {
            if (!this.filterName || !this.filters) return;
            try {
                const payload = this.filterExclude
                    ? JSON.stringify(this.filters, (key, value) =>
                        this.filterExclude.includes(key) ? undefined : value)
                    : JSON.stringify(this.filters);
                localStorage.setItem(this.filterName, payload);
            } catch (_) {
                // Quota exceeded or serialization error — best-effort, no throw.
            }
        }
    }
};
